import { CTAColorVariant } from '~/components/shared/CTAButton';

const DEFAULT_PROPS = {
  headlineColor: 'black',
  headline: 'See how Walmart+ compares against the other brands.',
  subheadline: '',
  header1: 'Prime',
  header2: 'Circle 360',
  header3: 'Instacart+',
  baseSiteComparisons: [
    {
      text: 'Monthly plan',
      disclaimer: '',
      WalmartPlus: 'text',
      walmartText: '$12.95/mo.',
      Prime: 'text',
      primeText: '$14.99/mo.',
      Circle360: 'text',
      circle360Text: '$10.99/mo.',
      Instacart: 'text',
      instacartText: '$9.99/mo. (+ service fees)',
    },
    {
      text: 'Free same-day Delivery',
      disclaimer:
        '_BOLD_Delivery:_BOLD_ Free delivery requires $35 order minimum. Restrictions apply.',
      WalmartPlus: 'check',
      walmartText: '',
      Prime: 'x',
      primeText: '',
      Circle360: 'check',
      circle360Text: '',
      Instacart: 'x',
      instacartText: '',
    },
    {
      text: 'Video Streaming Choice',
      disclaimer: `_BOLD_Video Streaming Choice:_BOLD_ Choose one ad-supported service every 90 days: Peacock Premium or Paramount+ Essential. Add’l registration req’d. T&C apply.`,
      WalmartPlus: 'text',
      walmartText: 'Paramount+ or Peacock',
      Prime: 'text',
      primeText: 'Prime Video',
      Circle360: 'x',
      circle360Text: '',
      Instacart: 'text',
      instacartText: 'Peacock',
    },
    {
      text: '10¢ off/gallon at Gas Stations',
      disclaimer:
        '_BOLD_Fuel perks:_BOLD_ Fuel discount varies by location & station, subject to change.',
      WalmartPlus: 'text',
      walmartText: 'at 13,000+ stations',
      Prime: 'text',
      primeText: 'at 7,000+ stations',
      Circle360: 'x',
      circle360Text: '',
      Instacart: 'x',
      instacartText: '',
    },
    {
      text: 'Free Returns from Home',
      disclaimer:
        '_BOLD_Returns from home:_BOLD_ Member must be home to return items and show return bar code for scanning on mobile device. Items may be returned within 90 days of receipt. Exclusions and restrictions apply. Eligible items only.',
      WalmartPlus: 'check',
      walmartText: '',
      Prime: 'check',
      primeText: '',
      Circle360: 'x',
      circle360Text: '',
      Instacart: 'x',
      instacartText: '',
    },
    {
      text: 'Free Online Pet Care',
      disclaimer:
        "_BOLD_Vet Care:_BOLD_ Includes standard Pawp membership only; additional services billed by Pawp directly. Pawp services only available on mobile and requires download of Pawp’s mobile app. By clicking “Get started”, you agree that we'll share your Walmart+ membership status with Pawp to validate benefit access. You'll be redirected to Pawp to create a new account. Services subject to Pawp’s Terms of Service.",
      WalmartPlus: 'check',
      walmartText: '',
      Prime: 'x',
      primeText: '',
      Circle360: 'x',
      circle360Text: '',
      Instacart: 'x',
      instacartText: '',
    },
    {
      text: 'Walmart Cash on travel bookings',
      disclaimer:
        '_BOLD_W+ Travel:_BOLD_ Travel savings based on 5% Walmart Cash on hotel bookings, vacation, car rentals, tours, activities & more, & 2% Walmart Cash on air travel.',
      WalmartPlus: 'check',
      walmartText: '',
      Prime: 'x',
      primeText: '',
      Circle360: 'x',
      circle360Text: '',
      Instacart: 'x',
      instacartText: '',
    },
    {
      text: 'Annual plan savings',
      disclaimer:
        '_BOLD_Free Trial:_BOLD_ After the trial, a Walmart+ membership is $12.95 per month or $98 per year.',
      WalmartPlus: 'text',
      walmartText: '$57.40',
      Prime: 'text',
      primeText: '$40.88',
      Circle360: 'text',
      circle360Text: '$32.88',
      Instacart: 'text',
      instacartText: '$20.88',
    },
  ],
  primaryCTA: {
    text: 'Claim your free trial',
    link: 'https://www.walmart.com/plus/plans',
    variant: 'primary-blue' as CTAColorVariant,
  },
  secondaryCTA: {
    text: '',
    link: 'https://www.walmart.com/plus/plans',
    variant: 'text-link' as CTAColorVariant,
  },
};

export default DEFAULT_PROPS;
